import React from 'react';
import { InputNumber, Form } from 'antd';
import { injectIntl } from 'react-intl';
import { validateDistance } from '../../../Utils/FormValidators';
import MultiLocationContext from '../MultiLocationContext';
import message from '../../../Containers/ManualSearchV2/ManualSearchMessages';

const MileSelect = props => {
  const {
    isRemoteJob,
    isCountryWideSearchEnabled,
    initialRange,
    isManualSearchFormMinimized,
    shouldHideManualSearchMiles,
    candidateContext = 'job',
    currentKey,
    currentLocation,
    locationContext,
    intl,
  } = props;

  const { isStateWideSearchChecked, onMilesChange, Distance, setMilesInputValidationError, milesInputValidationError } =
    React.useContext(MultiLocationContext);
  const getInitialRange = () => {
    if (initialRange) return Math.min(initialRange, 999);
    if (candidateContext === 'segment') return 100;
    return 5;
  };

  const inputStyle = { width: isManualSearchFormMinimized ? '122px' : '144px' };
  const isMilesDisabled = isCountryWideSearchEnabled || isRemoteJob || isStateWideSearchChecked(currentKey);
  const shouldHideMilesValidation = locationContext === 'Region' ? !currentLocation.Region : !currentLocation.Location;

  const onMileChange = value => {
    validateDistance(undefined, value, setMilesInputValidationError, isMilesDisabled, true, shouldHideMilesValidation);
    onMilesChange(value);
  };

  React.useEffect(() => {
    if (isMilesDisabled) setMilesInputValidationError();
    else
      validateDistance(
        undefined,
        Distance,
        setMilesInputValidationError,
        isMilesDisabled,
        true,
        shouldHideMilesValidation
      );
  }, [isMilesDisabled, shouldHideMilesValidation]);

  return (
    <div style={{ display: shouldHideManualSearchMiles ? 'none' : 'block', maxWidth: '144px' }}>
      <Form.Item
        validateStatus={milesInputValidationError ? 'error' : 'success'}
        help={milesInputValidationError}
        initialValue={getInitialRange()}
        style={{ maxHeight: '54px' }}
      >
        <InputNumber
          value={Distance === 0 ? undefined : Distance}
          // defaultValue={getInitialRange()}
          style={inputStyle}
          min={5}
          max={999}
           placeholder={isManualSearchFormMinimized ? intl.formatMessage({ ...message.maximumMilesLabel }) : intl.formatMessage({ ...message.maximumMilesForSourcingLabel })}
          disabled={isMilesDisabled}
          onChange={onMileChange}
          allowClear
        />
      </Form.Item>
    </div>
  );
};
export default (injectIntl(Form.create()(MileSelect)));
